import { Controller } from "@hotwired/stimulus";
import Rails from 'rails-ujs';

export default class extends Controller {
  connect() {
    if (this.shouldLoadReviews)
      return this.loadReviewsWithPagination(this.element.dataset.reviewsUrl);

    if (!this.pagination) return;

    this.pagination.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || !link.getAttribute('href')) return;

      event.preventDefault();
      this.loadReviewsWithPagination(link.getAttribute('href'));
    });
  }

  get shouldLoadReviews() {
    return this.element.dataset.reviewsLoad === 'true' && !this.pagination;
  }

  get pagination() {
    return this.element.querySelector('div.pagination');
  }

  get paginationLinks() {
    return this.element.querySelectorAll('div.pagination a');
  }

  get navigationLinks() {
    return this.element.querySelectorAll('div.pagination a.previous_page, div.pagination a.next_page');
  }

  loadReviewsWithPagination(url) {
    Rails.ajax({
      type: 'GET',
      dataType: 'script',
      url: url
    });
  }
}
